import { Message } from "primereact/message";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RadioButton } from "primereact/radiobutton";
import { useField } from "formik";


const CostComponent = ({ connection }) => {
    const { t } = useTranslation();
    const [field, , { setValue }] = useField({ name: "buy_seat" });

    if (!field?.value){
        setValue("service");
    }
    return (
        <div style={{ width: "100%" }}>
            {connection?.costo_proveedor && connection?.tipo_formulario !== "FEATURE"  && (
                <div className='disclaimer-price mb-3'>
                    <div className="mb-1" style={{ fontWeight: 600, fontSize: "14px" }}>
                        {t("marketplace.costoProveedor")}
                    </div>
                    <div className='message mb-3'>
                        <Message severity="info" text={t("marketplace.disclaimerCost")}  />
                    </div>
                    <div className='provider-cost'>
                        <div className='provider-title'>{connection?.nombre_servicio}</div>
                        <div className='cost-container'>
                            <div className='title'>{t("marketplace.detalleCosto")}</div>
                            <div className='cost'>{connection.costo_proveedor==="limitedFree"?t("marketplace.limitedFreeCost"):connection.costo_proveedor==="FREE"?t("marketplace.freeCost"):`US $${connection.costo_proveedor}`}</div>
                        </div>
                    </div>
                </div>
            )}
            <div className="mb-1" style={{ fontWeight: 600, fontSize: "14px" }}>
                {t("marketplace.costosWiseconn")}
            </div>
            <div className='mkt-cost-component mb-2'>
                {connection?.tipo_formulario === "API" || connection?.tipo_formulario === "API_SELFMANAGED" ? (
                    <>
                        <div className='item-container'>
                            <div className='item-title'>{t("marketplace.wiseconnItem")}</div>
                        </div>
                        <div className='item-container' style={{ background: "white" }}>
                            <div className='item-cost'>
                                <div className='d-flex align-items-center'>
                                    <RadioButton
                                        id="buy_seat"
                                        inputId="buy_seat"
                                        name="buy_seat"
                                        value="service"
                                        checked={field.value === "service"}
                                        onChange={e => setValue(e.value)}
                                        defaultChecked={field.value === "service"}
                                    />
                                    <label className='m-0 ml-2' htmlFor="buy_seat">{t("marketplace.servicio")}</label>
                                </div>
                                <div>
                                    {connection?.usd_price ? (
                                        `US${connection.usd_price.toFixed(2)} ${t("marketplace.monthly")}.`
                                    ) : (

                                        t("marketplace.unknownPrice")
                                    )}
                                </div>
                            </div>
                            <div className='ml-4 info-seat'>*{t("marketplace.applyOnlyFarm")}</div>
                            <div className='item-cost'>
                                <div className='d-flex align-items-center'>
                                    <RadioButton
                                        id="buy_seat"
                                        inputId="buy_seat"
                                        name="buy_seat"
                                        value="seat"
                                        checked={field.value === "seat"}
                                        onChange={e => setValue(e.value)}
                                    />
                                    <label className='m-0 ml-2' htmlFor="buy_seat">{t("marketplace.seat")}</label>
                                </div>
                                <div>
                                    {connection?.api_key_seat_cost ? (
                                        `US $${connection.api_key_seat_cost.toFixed(2)} ${t("marketplace.monthly")}.`
                                    ) : (
                                        t("marketplace.unknownPrice")
                                    )}
                                </div>
                            </div>
                            <div className='ml-4 info-seat' >*{t("marketplace.applyForClient")}</div>
                        </div>
                    </>
                ) :
                    connection?.tipo_formulario === "FEATURE"?(
                        <div className='item-container'>
                            <div className='item-title'>{t("marketplace.wiseconnItem")}</div>
                            <div className='item-cost'>
                                <div>{t("marketplace.servicio")}</div>
                                <div>
                                    {connection.costo_proveedor==="limitedFree"?
                                        t("marketplace.limitedFreeCost"):
                                        connection?.costo_proveedor ? (
                                            `US${connection.costo_proveedor.toFixed(2)} ${t("marketplace.monthly")}.`)
                                            :(t("marketplace.unknownPrice"))}
                                </div>
                            </div>
                        </div>
                    ):(
                        <div className='item-container'>
                            <div className='item-title'>{t("marketplace.wiseconnItem")}</div>
                            <div className='item-cost'>
                                <div>{t("marketplace.servicio")}</div>
                                <div>
                                    {connection?.usd_price ? (
                                        `US${connection.usd_price.toFixed(2)} ${t("marketplace.monthly")}.`
                                    ) : (
                                        t("marketplace.unknownPrice")
                                    )}
                                </div>
                            </div>
                        </div>
                    // {/* <div className='cost-container'>
                    //     <div>Total</div>
                    //     <div>
                    //         {price ? (
                    //             `US${price.toFixed(2)} ${t("marketplace.monthly")}.`
                    //         ) : (
                    //             t("marketplace.unknownPrice")
                    //         )}
                    //     </div>
                    // </div> */}
                    )}
            </div>
        </div>
    );
};

export default CostComponent;
